function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "\\u4E0B\\u79FB\\u4E00\\u5C64",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-2-Copy",
  transform: "translate(3.000000, 3.000000)",
  fill: "#555555",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.65807804,0.9951338 C9.13519561,0.7706729 9.68799074,0.74822681 10.1802438,0.92779553 L10.3826777,1.01472782 L17.9487431,4.76570555 C18.9039694,5.21509367 19.2958954,6.34441277 18.7581861,7.25589182 C18.6090813,7.50864168 18.3996989,7.72039152 18.1624787,7.87023161 L18.0170656,7.95253922 L12,11.1682928 L12,8.62877716 L12.533,8.628 L12.5286528,8.61805223 L16.71,6.383 L9.499,2.809 L2.29,6.383 L6.4713453,8.61805124 L6.466,8.628 L7,8.62877716 L7,11.1682928 L1.0042142,7.96359762 C0.0602703648,7.48788236 -0.295939437,6.34565824 0.270106935,5.4499522 C0.426529331,5.20243098 0.641548548,4.9972545 0.884174264,4.85340258 L1.03281455,4.77460221 L8.65807804,0.9951338 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Line",
  points: "10.5 6 10.5 18 8.5 18 8.5 6"
})), /*#__PURE__*/React.createElement("polygon", {
  id: "Path-Copy",
  transform: "translate(9.500000, 16.221089) rotate(-180.000000) translate(-9.500000, -16.221089) ",
  points: "5.34920863 17.2407434 9.5 13.6829222 13.6507914 17.2407434 12.3492086 18.7592566 9.5 16.317 6.65079137 18.7592566"
})));

function SvgDowner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u4E0B\u79FB\u4E00\u5C64") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDowner);
export default __webpack_public_path__ + "static/media/downer.f15706bc.svg";
export { ForwardRef as ReactComponent };